import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";

export default function useCurrentCRI() {
    const product = useCurrentProduct();

    return product?.properties.cri ?? null;
}
